var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"display-4"},[_vm._v("Teleatendimento")]),_c('hr'),_c('az-video-call')],1)}
var staticRenderFns = []

export { render, staticRenderFns }